import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getFollowersCount = async (id: string) => {
  const [
    { count: followers, error: followersError },
    { count: following, error: followingError },
    { count: assets, error: assetError },
  ] = await Promise.all([
    supabase
      .from('following_users')
      .select('*', { count: 'exact', head: true })
      .eq('follow_user_id', id),
    supabase
      .from('following_users')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', id),
    supabase
      .from('following_users_assets')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', id),
  ])

  if (followersError) {
    throw new Error(followersError.message)
  }
  if (followingError) {
    throw new Error(followingError.message)
  }

  if (assetError) {
    throw new Error(assetError.message)
  }

  return { followers, following, assets }
}

export default function useUserFollowersFollowingCount(id: string) {
  return useQuery({
    queryKey: ['userFollowingCount', id],
    queryFn: () => getFollowersCount(id),
    enabled: Boolean(id),
    staleTime: 60000,
  })
}
